import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddStickyNote = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "sticky-note-line",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M21 15L15 20.996L4.00221 21C3.4487 21 3 20.5551 3 20.0066V3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.45576 21 4.00247V15ZM19 5H5V19H13V14C13 13.4872 13.386 13.0645 13.8834 13.0067L14 13L19 12.999V5ZM18.171 14.999L15 15V18.169L18.171 14.999Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M19 0V3H16V5H19V8H21V5H24V3H21V0H19Z",
			fill: "#0587FB"
		})]
	})
});
export default SvgAddStickyNote;
